module.exports = __webpack_public_path__ + "img/light-mud-decal-17.fa46a33c.png";